import { ProgressBar } from "react-loader-spinner"




export const CustomLoader: React.FC = () => {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',  // Full viewport height to center vertically
      }}>
        <ProgressBar
          visible={true}
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          borderColor="var(--bs-secondary)"
          barColor="var(--bs-primary)"
        />
      </div>
    );
  };
  